import React from 'react'
import { useNavigate } from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { safeFormat } from '@/v2/utils/convert'
import { formatPhone, healthHistoryOf } from '../utils'
import {
  Row,
  Sub,
  PatientName,
  VirtualTag,
  Phone,
  HealthHistory,
  Actions,
  ActionButton,
  Confirmed,
  Muted,
} from '../styles'

const Reminders = ({ reminders }) => {
  if (!reminders?.sentCount) {
    return <Muted>None yet</Muted>
  }

  return (
    <>
      {reminders.sentCount} sent
      <Sub>Last: {safeFormat(reminders.lastSentAt, 'EEE, MMM d · h:mm a')}</Sub>
    </>
  )
}

const AppointmentRow = ({
  appointment,
  confirmed,
  onMessage,
  onConfirm,
  onUndo,
  onCancel,
}) => {
  const navigate = useNavigate()
  const { patient, appointmentType, doctor, startsAt, virtual } = appointment
  const healthHistory = healthHistoryOf(appointment)
  const when = [
    safeFormat(startsAt, 'EEE, MMM d'),
    safeFormat(startsAt, 'h:mm a'),
    doctor && `Dr. ${doctor.fullName}`,
  ]
    .filter(Boolean)
    .join(' · ')

  return (
    <Row $confirmed={confirmed}>
      <div>
        <PatientName
          type="button"
          onClick={() => navigate(`/v2/patient/${patient.id}/profile`)}
        >
          {patient.fullName}
        </PatientName>
        {virtual && <VirtualTag>Virtual</VirtualTag>}
        <Sub>Patient #{patient.id}</Sub>
      </div>

      <div>
        {appointmentType?.title}
        <Sub>{when}</Sub>
      </div>

      <div>
        {patient.phoneNumber ? (
          <Phone href={`tel:${patient.phoneNumber}`}>
            <PhoneIcon />
            {formatPhone(patient.phoneNumber)}
          </Phone>
        ) : (
          <Muted>No phone</Muted>
        )}
      </div>

      <div>
        <HealthHistory $tone={healthHistory.tone}>
          {healthHistory.label}
        </HealthHistory>
      </div>

      <div>
        <Reminders reminders={appointment.reminders} />
      </div>

      <Actions>
        {confirmed ? (
          <Confirmed>
            ✓ Confirmed
            <button type="button" onClick={onUndo}>
              Undo
            </button>
          </Confirmed>
        ) : (
          <>
            <ActionButton
              type="button"
              disabled={!appointment.conversationId}
              onClick={onMessage}
            >
              <ChatBubbleOutlineIcon />
              Message
            </ActionButton>
            <ActionButton type="button" $variant="confirm" onClick={onConfirm}>
              Confirm
            </ActionButton>
            <ActionButton type="button" $variant="cancel" onClick={onCancel}>
              Cancel
            </ActionButton>
          </>
        )}
      </Actions>
    </Row>
  )
}

export default AppointmentRow
